import React__default, { useMemo } from 'react';
import { businessFilterPanelIsOpenState, activeBusinessFiltersState, MediaField } from '@keepeek/commons';
import { useRecoilState, useRecoilValue } from 'recoil';
import BusinessFilterToggler$1 from '../BusinessFilter/BusinessFilterToggler/index.js';

var BusinessFilterToggler = function (_a) {
    var KIcon = _a.KIcon, dataViewKey = _a.dataViewKey;
    var _b = useRecoilState(businessFilterPanelIsOpenState), isOpen = _b[0], setIsOpen = _b[1];
    var activeFilters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var activeFiltersCount = useMemo(function () {
        return (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.filter(function (f) { return f.filter.id !== MediaField.FOLDER_ID && f.hide !== true; }).length) || 0;
    }, [activeFilters]);
    return (React__default.createElement(BusinessFilterToggler$1, { count: activeFiltersCount, active: isOpen, KIcon: KIcon, onToggle: function () { return setIsOpen(function (prev) { return !prev; }); } }));
};

export { BusinessFilterToggler as default };
//# sourceMappingURL=BusinessFilterToggler.js.map
